import { Stack, type StackProps } from '@iconik-io/uad';

/**
 * Standard form actions layout used with `form.CancelButton` and `form.SubmitButton`.
 */
export function FormActions(props: StackProps) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="end"
      gap="xl"
      {...props}
    />
  );
}
